import { request } from './api'

export function requestSlides() {
  return request('slide', 'post', { name: 'patroltec' })
}

export function requestWelcomImages() {
  return request('welcome-images', 'post')
}
